import { Brand, createBranded } from '@deltasierra/type-utilities';

export type LinkedInOrganizationId = Brand<string, 'LinkedInOrganizationId'>;
export const LinkedInOrganizationId = createBranded<LinkedInOrganizationId>();
